export const TIME_TO_SWITCH_ADS_10SEC = 10000;
export const TIME_TO_SWITCH_ADS_5SEC = 5000;